import m from 'mithril';
import { Classes } from '../../_shared';
var MenuDivider = /** @class */ (function () {
    function MenuDivider() {
    }
    MenuDivider.prototype.view = function () {
        return m("." + Classes.MENU_DIVIDER);
    };
    return MenuDivider;
}());
export { MenuDivider };
